import moment from 'moment';
import 'moment/min/locales';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import '../../assets/css/timeline.css';
import AjaxHandler from '../../commons/ajax/AjaxHandler.js';
import Loading from '../ui/Loading.js';

class RepuestoHistorico extends Component {
  constructor(props) {
    super(props);

    this.ajaxHandler = new AjaxHandler();
    moment.locale('es');

    this.state = {
      loading: false,
      historia: [],
    };
  }

  componentDidMount() {
    this.ajaxHandler.subscribe(this);
    this.loadFormData();
  }

  componentWillUnmount() {
    this.ajaxHandler.unsubscribe();
  }

  loadFormData() {
    const repuestoId = this.props.repuesto ? this.props.repuesto.id : null;
    if (!repuestoId) {
      if (this.props.onHistoricoLoaded) this.props.onHistoricoLoaded(false);
      return;
    }

    const component = this;
    this.setState({ loading: true });
    this.ajaxHandler
      .getJson('/panol2/repuestos/' + repuestoId + '/historico/grid')
      .then((data) => {
        const historia = data || [];
        component.setState({ historia: historia });
        if (component.props.onHistoricoLoaded) component.props.onHistoricoLoaded(historia.length > 0);
        component.setState({ loading: false });
      });
  }

  getCampoLabel(campo) {
    switch (campo) {
      case 'costo':
        return this.props.intl.formatMessage({
          id: 'repuestoHistorico.campo.costo',
          defaultMessage: 'Costo',
        });
      case 'costo_fijo':
        return this.props.intl.formatMessage({
          id: 'repuestoHistorico.campo.costo_fijo',
          defaultMessage: 'Costo fijo',
        });
      default:
        return campo;
    }
  }

  formatValor(campo, valor) {
    if (valor === null || valor === undefined || valor === '') return '-';

    if (campo === 'costo_fijo') {
      const v = valor === 1 || valor === '1' || valor === true || valor === 'true';
      return v
        ? this.props.intl.formatMessage({ id: 'Si', defaultMessage: 'Si' })
        : this.props.intl.formatMessage({ id: 'No', defaultMessage: 'No' });
    }

    if (campo === 'costo') {
      const num = parseFloat(valor);
      if (!isNaN(num)) return num.toLocaleString('de-DE');
    }

    return '' + valor;
  }

  getUsuarioDisplay(item) {
    if (item && item.per_nombre) {
      return item.per_nombre + ' ' + item.per_apellido;
    }
    return this.props.intl.formatMessage({
      id: 'repuestoHistorico.usuario.sistema',
      defaultMessage: 'Generado por el sistema',
    });
  }

  render() {
    if (!this.props.repuesto) return null;

    return (
      <React.Fragment>
        {this.state.loading && <Loading />}
        <div className="content-wrapper">
          <div className="content-body">
            <section id="timeline" className="timeline-left timeline-wrapper">
              <ul className="timeline">
                <li className="timeline-line"></li>
                {!this.state.loading && (!this.state.historia || this.state.historia.length === 0) && (
                  <li className="timeline-item">
                    <div className="timeline-card card border-grey border-lighten-2 card-history">
                      <div className="card-header">
                        <h4 className="card-title">
                          {this.props.intl.formatMessage({
                            id: 'repuestoHistorico.sinCambios',
                            defaultMessage: 'No hubo cambios en el costo.',
                          })}
                        </h4>
                      </div>
                    </div>
                  </li>
                )}
                {this.state.historia.map((item, index) => {
                  const usuario = this.getUsuarioDisplay(item);
                  const campoLabel = this.getCampoLabel(item.campo);
                  const valorAnterior = this.formatValor(item.campo, item.valor_anterior);
                  const valorNuevo = this.formatValor(item.campo, item.valor_nuevo);
                  const esCambioCosto = item && item.campo === 'costo';

                  return (
                    <li key={index} className={esCambioCosto ? "timeline-item status-change" : "timeline-item"}>
                      <div className="timeline-badge">
                        <span className="bg-fleet bg-lighten-1" data-toggle="tooltip" data-placement="right">
                          <i className={esCambioCosto ? "la la-usd" : "la la-history"}></i>
                        </span>
                      </div>
                      <div className="timeline-card card border-grey border-lighten-2 card-history">
                        <div className="card-header">
                          <h4 className="card-title">
                            {moment(item.fecha_hora).format('L') +
                              ' - ' +
                              this.props.intl.formatMessage(
                                {
                                  id: 'repuestoHistorico.evento.cambioCampo',
                                  defaultMessage: 'Cambio de {campo}',
                                },
                                { campo: campoLabel }
                              ) +
                              ' - ' +
                              usuario}
                          </h4>
                          <p className="card-subtitle text-muted pt-1">
                            <span className="font-small-3">
                              <FormattedMessage
                                id="repuestoHistorico.detalle"
                                defaultMessage="{campo}: {anterior} → {nuevo}"
                                values={{
                                  campo: campoLabel,
                                  anterior: valorAnterior,
                                  nuevo: valorNuevo,
                                }}
                              />
                            </span>
                          </p>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </section>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default injectIntl(RepuestoHistorico);

